<!-- Activaciones pendientes post-pago (Plan 28, 2026-08-03) -->
<div class="space-y-4">

  <!-- Header con descripción -->
  <div class="bg-white rounded-lg shadow p-4">
    <h2 class="text-lg font-bold text-gray-800 flex items-center">
      <i class="fas fa-clock mr-2 text-orange-500"></i>
      Activaciones pendientes con Venemergencias
    </h2>
    <p class="text-sm text-gray-600 mt-1">
      Casos donde el cliente pagó pero la afiliación al aliado no se completó automáticamente.
      Usa <strong>Reintentar</strong> para volver a llamar al gateway, o
      <strong>Marcar como resuelto</strong> cuando Venemergencias ya registró el caso manualmente.
    </p>
  </div>

  <!-- KPIs -->
  <div *ngIf="kpis" class="grid grid-cols-2 md:grid-cols-5 gap-3">
    <div class="bg-white rounded-lg shadow p-3">
      <div class="text-xs text-gray-500 uppercase">Total</div>
      <div class="text-2xl font-bold text-gray-800">{{ kpis.total }}</div>
    </div>
    <div class="bg-white rounded-lg shadow p-3 border-l-4 border-yellow-400">
      <div class="text-xs text-gray-500 uppercase">Pendientes</div>
      <div class="text-2xl font-bold text-yellow-700">{{ kpis.awaiting_action }}</div>
    </div>
    <div class="bg-white rounded-lg shadow p-3 border-l-4 border-red-400">
      <div class="text-xs text-gray-500 uppercase">Escaladas</div>
      <div class="text-2xl font-bold text-red-700">{{ kpis.escalated }}</div>
    </div>
    <div class="bg-white rounded-lg shadow p-3 border-l-4 border-green-400">
      <div class="text-xs text-gray-500 uppercase">Resueltas</div>
      <div class="text-2xl font-bold text-green-700">{{ kpis.resolved }}</div>
    </div>
    <div class="bg-white rounded-lg shadow p-3">
      <div class="text-xs text-gray-500 uppercase">Prom. reintentos</div>
      <div class="text-2xl font-bold text-gray-800">{{ kpis.avg_retries }}</div>
    </div>
  </div>

  <!-- Filtros -->
  <div class="bg-white rounded-lg shadow p-4">
    <div class="grid grid-cols-1 md:grid-cols-5 gap-3 items-end">
      <div>
        <label class="block text-xs font-medium text-gray-600 mb-1">Desde</label>
        <input type="date" [(ngModel)]="startDate" class="w-full border border-gray-300 rounded px-2 py-1.5 text-sm">
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-600 mb-1">Hasta</label>
        <input type="date" [(ngModel)]="endDate" class="w-full border border-gray-300 rounded px-2 py-1.5 text-sm">
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-600 mb-1">Estado</label>
        <select [(ngModel)]="statusFilter" class="w-full border border-gray-300 rounded px-2 py-1.5 text-sm">
          <option value="all">Todos</option>
          <option value="failed">Pendientes</option>
          <option value="escalated">Escaladas</option>
          <option value="resolved">Resueltas</option>
        </select>
      </div>
      <div class="md:col-span-1">
        <label class="block text-xs font-medium text-gray-600 mb-1">Buscar (CI / nombre / tel / email)</label>
        <input type="text" [(ngModel)]="personSearch" placeholder="Ej: V19815743"
               class="w-full border border-gray-300 rounded px-2 py-1.5 text-sm">
      </div>
      <div class="flex gap-2 flex-wrap">
        <button (click)="onApplyFilters()"
                class="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded text-sm font-medium">
          <i class="fas fa-filter mr-1"></i> Aplicar
        </button>
        <button (click)="onClearFilters()"
                class="border border-gray-300 hover:bg-gray-100 px-3 py-1.5 rounded text-sm">
          Limpiar
        </button>
        <button (click)="onExport()" [disabled]="exporting || loading || total === 0"
                title="Descargar Excel con los datos filtrados para enviar a Venemergencias"
                class="bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded text-sm font-medium disabled:opacity-40 disabled:cursor-not-allowed">
          <i class="fas" [class.fa-spinner]="exporting" [class.fa-spin]="exporting" [class.fa-file-excel]="!exporting"></i>
          {{ exporting ? ' Exportando...' : ' Exportar Excel' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Loading / Error -->
  <div *ngIf="loading" class="bg-white rounded-lg shadow p-8 text-center text-gray-500">
    <i class="fas fa-spinner fa-spin mr-2"></i> Cargando...
  </div>
  <div *ngIf="loadError && !loading" class="bg-red-50 border border-red-200 rounded-lg p-4 text-red-700 text-sm">
    <i class="fas fa-exclamation-circle mr-2"></i> {{ loadError }}
  </div>

  <!-- Tabla -->
  <div *ngIf="!loading && !loadError" class="bg-white rounded-lg shadow overflow-hidden">
    <div *ngIf="items.length === 0" class="p-8 text-center text-gray-500">
      <i class="fas fa-inbox text-3xl mb-2 block"></i>
      No hay activaciones pendientes con los filtros actuales.
    </div>

    <table *ngIf="items.length > 0" class="min-w-full text-sm">
      <thead class="bg-gray-50 text-gray-600 text-xs uppercase">
        <tr>
          <th class="px-3 py-2 text-left w-8"></th>
          <th class="px-3 py-2 text-left">Fecha</th>
          <th class="px-3 py-2 text-left">Cliente</th>
          <th class="px-3 py-2 text-left">CI</th>
          <th class="px-3 py-2 text-left">Teléfono</th>
          <th class="px-3 py-2 text-left">Estado</th>
          <th class="px-3 py-2 text-center">Reintentos</th>
          <th class="px-3 py-2 text-left">Último error</th>
          <th class="px-3 py-2 text-right">Acciones</th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-200">
        <ng-container *ngFor="let row of items">
          <tr class="hover:bg-gray-50">
            <td class="px-3 py-2">
              <button (click)="toggleExpand(row.policy_code)" class="text-gray-400 hover:text-gray-700">
                <i class="fas" [class.fa-chevron-right]="expandedCode !== row.policy_code" [class.fa-chevron-down]="expandedCode === row.policy_code"></i>
              </button>
            </td>
            <td class="px-3 py-2 whitespace-nowrap text-gray-700">{{ formatDateShort(row.created_at) }}</td>
            <td class="px-3 py-2 text-gray-800">{{ row.insured.name || '—' }}</td>
            <td class="px-3 py-2 font-mono text-xs text-gray-600">{{ row.insured.ci || '—' }}</td>
            <td class="px-3 py-2 text-gray-600">{{ row.insured.phone || '—' }}</td>
            <td class="px-3 py-2">
              <span class="inline-block px-2 py-0.5 text-xs font-semibold rounded" [ngClass]="statusBadge(row).cls">
                {{ statusBadge(row).label }}
              </span>
            </td>
            <td class="px-3 py-2 text-center">
              <span class="text-xs" [class.text-red-600]="row.retries.remaining === 0" [class.font-semibold]="row.retries.remaining === 0">
                {{ row.retries.count }} / {{ row.retries.max }}
              </span>
            </td>
            <td class="px-3 py-2 text-xs text-gray-600 max-w-xs truncate" [title]="row.last_hook_error.msg || ''">
              <span *ngIf="row.last_hook_error.status" class="font-semibold mr-1">[{{ row.last_hook_error.status }}]</span>
              {{ row.last_hook_error.msg || '—' }}
            </td>
            <td class="px-3 py-2 text-right whitespace-nowrap">
              <button (click)="onRetry(row)"
                      [disabled]="retryingCode === row.policy_code || resolvingCode === row.policy_code || row.resolved.flag"
                      [title]="row.resolved.flag ? 'Ya resuelta' : 'Reintentar afiliación'"
                      class="bg-blue-100 hover:bg-blue-200 text-blue-800 px-2 py-1 rounded text-xs mr-1 disabled:opacity-40 disabled:cursor-not-allowed">
                <i class="fas" [class.fa-spinner]="retryingCode === row.policy_code" [class.fa-spin]="retryingCode === row.policy_code" [class.fa-redo]="retryingCode !== row.policy_code"></i>
                Reintentar
              </button>
              <button (click)="openResolveModal(row)"
                      [disabled]="retryingCode === row.policy_code || resolvingCode === row.policy_code || row.resolved.flag"
                      [title]="row.resolved.flag ? 'Ya resuelta' : 'Marcar como resuelto (consulta al aliado)'"
                      class="bg-green-100 hover:bg-green-200 text-green-800 px-2 py-1 rounded text-xs disabled:opacity-40 disabled:cursor-not-allowed">
                <i class="fas fa-check-circle"></i>
                Resolver
              </button>
            </td>
          </tr>
          <!-- Mensaje de acción por fila -->
          <tr *ngIf="actionMsg && actionMsg.code === row.policy_code">
            <td colspan="9" class="px-3 py-2">
              <div class="rounded p-2 text-xs"
                   [ngClass]="{
                     'bg-green-50 border border-green-200 text-green-800': actionMsg.type === 'success',
                     'bg-red-50 border border-red-200 text-red-800': actionMsg.type === 'error',
                     'bg-blue-50 border border-blue-200 text-blue-800': actionMsg.type === 'info'
                   }">
                {{ actionMsg.text }}
              </div>
            </td>
          </tr>
          <!-- Panel expandido con snapshot completo -->
          <tr *ngIf="expandedCode === row.policy_code" class="bg-gray-50">
            <td colspan="9" class="px-6 py-4">
              <div class="grid grid-cols-1 md:grid-cols-3 gap-4 text-xs">
                <div>
                  <div class="font-semibold text-gray-700 mb-1">Asegurado</div>
                  <div class="text-gray-600">Nombre: {{ row.insured.name || '—' }}</div>
                  <div class="text-gray-600">CI: {{ row.insured.ci || '—' }}</div>
                  <div class="text-gray-600">Teléfono: {{ row.insured.phone || '—' }}</div>
                  <div class="text-gray-600">Email: {{ row.insured.email || '—' }}</div>
                  <div class="text-gray-600">Nac.: {{ row.insured.birth_day || '—' }}</div>
                  <div class="text-gray-600">Género: {{ row.insured.gender || '—' }}</div>
                  <div class="text-gray-600">Plaza: {{ row.insured.place || '—' }}</div>
                </div>
                <div>
                  <div class="font-semibold text-gray-700 mb-1">Plan</div>
                  <div class="text-gray-600">Meses: {{ row.plan.months || '—' }}</div>
                  <div class="text-gray-600">Insurance code: {{ row.plan.insurance_code || '—' }}</div>
                  <div class="text-gray-600">Origen: {{ row.plan.origin || '—' }}</div>
                  <div class="text-gray-600 font-mono truncate" [title]="row.plan.plan_id || ''">Plan ID: {{ row.plan.plan_id || '—' }}</div>
                  <div class="font-semibold text-gray-700 mt-3 mb-1">Pago</div>
                  <div class="text-gray-600">Monto: {{ formatAmount(row.payment.amount_usd, row.payment.amount_bs) }}</div>
                  <div class="text-gray-600">Método: {{ row.payment.method || '—' }}</div>
                  <div class="text-gray-600">Ref: <span class="font-mono">{{ row.payment.reference || '—' }}</span></div>
                  <div class="text-gray-600">Fecha: {{ formatDate(row.payment.timestamp) }}</div>
                </div>
                <div>
                  <div class="font-semibold text-gray-700 mb-1">Reintentos y estado</div>
                  <div class="text-gray-600">Usados: {{ row.retries.count }} / {{ row.retries.max }}</div>
                  <div class="text-gray-600">Restantes cliente: {{ row.retries.remaining }}</div>
                  <div class="text-gray-600 mt-2" *ngIf="row.escalated.flag">
                    <span class="text-red-700 font-semibold">Escalada</span>
                    el {{ formatDate(row.escalated.at) }} por {{ row.escalated.by || '—' }}
                  </div>
                  <div class="text-gray-600" *ngIf="row.escalated.reason">Motivo: {{ row.escalated.reason }}</div>
                  <div class="text-gray-600 mt-2" *ngIf="row.resolved.flag">
                    <span class="text-green-700 font-semibold">Resuelta</span>
                    el {{ formatDate(row.resolved.at) }} por {{ row.resolved.by || '—' }}
                  </div>
                  <div class="text-gray-600 italic mt-1" *ngIf="row.resolved.comment">"{{ row.resolved.comment }}"</div>
                  <div class="font-semibold text-gray-700 mt-3 mb-1" *ngIf="row.integration_data.sav_insured_id">Integración</div>
                  <div class="text-gray-600 font-mono truncate" *ngIf="row.integration_data.sav_insured_id" [title]="row.integration_data.sav_insured_id">
                    sav: {{ row.integration_data.sav_insured_id }}
                  </div>
                  <div class="text-gray-600" *ngIf="row.integration_data.start_date">Vigencia: {{ formatDateShort(row.integration_data.start_date) }} → {{ formatDateShort(row.integration_data.end_date) }}</div>
                  <div class="font-semibold text-gray-700 mt-3 mb-1">Último error del gateway</div>
                  <div class="text-gray-600" *ngIf="row.last_hook_error.status">HTTP {{ row.last_hook_error.status }} — {{ formatDate(row.last_hook_error.at) }}</div>
                  <div class="text-gray-600 italic" *ngIf="row.last_hook_error.msg">{{ row.last_hook_error.msg }}</div>
                </div>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>

    <!-- Paginación -->
    <div *ngIf="items.length > 0" class="flex items-center justify-between px-4 py-3 bg-gray-50 border-t">
      <div class="text-xs text-gray-600">
        Página {{ page }} de {{ totalPages }} — {{ total }} registros
      </div>
      <div class="flex gap-1">
        <button (click)="goToPage(page - 1)" [disabled]="page <= 1"
                class="border border-gray-300 hover:bg-gray-100 px-3 py-1 rounded text-xs disabled:opacity-40 disabled:cursor-not-allowed">
          <i class="fas fa-chevron-left"></i> Anterior
        </button>
        <button (click)="goToPage(page + 1)" [disabled]="page >= totalPages"
                class="border border-gray-300 hover:bg-gray-100 px-3 py-1 rounded text-xs disabled:opacity-40 disabled:cursor-not-allowed">
          Siguiente <i class="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal: Marcar como resuelto -->
<div *ngIf="resolveModalOpen" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
  <div class="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
    <h3 class="text-lg font-bold text-gray-800 flex items-center mb-2">
      <i class="fas fa-check-circle text-green-500 mr-2"></i>
      Confirmar resolución con Venemergencias
    </h3>
    <p class="text-xs text-gray-600 mb-4">
      Al confirmar, el sistema consultará al aliado para validar que el asegurado ya está registrado.
      Sólo procederá si Venemergencias tiene el registro. Sin override manual.
    </p>

    <label class="block text-xs font-medium text-gray-700 mb-1">
      Comentario (obligatorio, mín. 5 caracteres)
    </label>
    <textarea [(ngModel)]="resolveComment" rows="3" maxlength="500"
              placeholder="Ej: Confirmado con Ana de Venemergencias por WhatsApp; ya está en su sistema."
              class="w-full border border-gray-300 rounded p-2 text-sm mb-2"></textarea>

    <div *ngIf="resolveError" class="bg-red-50 border border-red-200 text-red-700 text-xs p-2 rounded mb-3">
      <i class="fas fa-exclamation-triangle mr-1"></i> {{ resolveError }}
    </div>

    <div class="flex justify-end gap-2 mt-4">
      <button (click)="closeResolveModal()" [disabled]="!!resolvingCode"
              class="border border-gray-300 hover:bg-gray-100 px-4 py-1.5 rounded text-sm disabled:opacity-40">
        Cancelar
      </button>
      <button (click)="confirmResolve()" [disabled]="!!resolvingCode"
              class="bg-green-600 hover:bg-green-700 text-white px-4 py-1.5 rounded text-sm disabled:opacity-40">
        <i class="fas" [class.fa-spinner]="!!resolvingCode" [class.fa-spin]="!!resolvingCode" [class.fa-check]="!resolvingCode"></i>
        Confirmar
      </button>
    </div>
  </div>
</div>
